import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import config from '../../../config';

const CycleTimeNew = ({ selectedDate }) => {
  const [data, setData] = useState({ PM2: { 총: {}, 실: {} }, PM3: { 총: {}, 실: {} }, 합계: { 총: {}, 실: {} } });
  const [loading, setLoading] = useState(false); // 로컬 로딩 상태

  // selectedDate가 Date 객체인지 확인하고 Date 객체로 변환
  const dateObj = new Date(selectedDate);
  const formattedDate = isValid(dateObj) ? format(dateObj, 'yyyyMMdd') : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!formattedDate) return;

      setLoading(true); // 로컬 로딩 상태 활성화

      try {
        const response = await axios.post(
          `${config.apiUrl}/runSel.do`,
          { stdate: formattedDate },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;
        const transformedData = transformData(apiData);
        setData(transformedData);
      } catch (err) {
        // 에러 처리
      } finally {
        setLoading(false); // 로딩 종료
      }
    };

    fetchData();
  }, [formattedDate]);

  // 숫자에 콤마를 추가하는 함수
  const formatNumber = num => (typeof num === 'number' ? num.toLocaleString() : num);

  // 데이터 변환 함수
  const transformData = apiData => {
    const machines = {
      PM2: { 총: { 목표: '', 실적: '', '달성율(%)': '' }, 실: { 목표: '', 실적: '', '달성율(%)': '' } },
      PM3: { 총: { 목표: '', 실적: '', '달성율(%)': '' }, 실: { 목표: '', 실적: '', '달성율(%)': '' } },
      합계: { 총: { 목표: '', 실적: '', '달성율(%)': '' }, 실: { 목표: '', 실적: '', '달성율(%)': '' } },
    };

    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const totalKeys = {
          목표: ['PM2P', 'PM3P', 'CP'],
          실적: ['PM2C', 'PM3C', 'C'],
          '달성율(%)': ['PM2D', 'PM3D', 'PMDP'],
        };

        const actualKeys = {
          목표: ['PM2PS', 'PM3PS', 'SP'],
          실적: ['PM2S', 'PM3S', 'S'],
          '달성율(%)': ['PM2DS', 'PM3DS', 'PMDS'],
        };

        // 총가동 데이터 처리
        Object.keys(totalKeys).forEach(category => {
          const totalCategoryKeys = totalKeys[category];

          if (totalCategoryKeys) {
            if (entry[totalCategoryKeys[0]] !== undefined)
              machines.PM2.총[category] = formatNumber(entry[totalCategoryKeys[0]]);
            if (entry[totalCategoryKeys[1]] !== undefined)
              machines.PM3.총[category] = formatNumber(entry[totalCategoryKeys[1]]);
            if (entry[totalCategoryKeys[2]] !== undefined)
              machines.합계.총[category] = formatNumber(entry[totalCategoryKeys[2]]);
          }
        });

        // 실가동 데이터 처리
        Object.keys(actualKeys).forEach(category => {
          const actualCategoryKeys = actualKeys[category];

          if (actualCategoryKeys) {
            if (entry[actualCategoryKeys[0]] !== undefined)
              machines.PM2.실[category] = formatNumber(entry[actualCategoryKeys[0]]);
            if (entry[actualCategoryKeys[1]] !== undefined)
              machines.PM3.실[category] = formatNumber(entry[actualCategoryKeys[1]]);
            if (entry[actualCategoryKeys[2]] !== undefined)
              machines.합계.실[category] = formatNumber(entry[actualCategoryKeys[2]]);
          }
        });
      });
    }

    return machines;
  };

  // 카테고리와 데이터가 있는 상태로 초기화
  const categories = ['목표', '실적', '달성율(%)'];

  return (
    <div className='relative mt-[4%]'>
      {loading && (
      <div className='absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10'>
        <div className="text-white text-2xl font-bold">Loading...</div>
      </div>
      )}
      <div className='w-[25%] change_2h page_center bg-blue-200 font-bold text-blue-600'>가동율(%)</div>
      <div className='b2-box'>
        <div className='flex flex-row'>
          {/* 상위 헤더 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>구분</div>
            <div className='flex flex-col w-[100%]'>
              <div className='flex flex-row'>
                 <div className='w-[40%] change_2h3 b2-r b2-b page_center border-black border-b-2'>
                  <div className='w-[100%] flex flex-col items-center justify-center'>
                    <div className='flex flex-row items-center'>
                      <span className='font-bold text-center'>총</span>
                      <span className='text-center'>가</span>
                      <span className='text-center'>동</span>
                    </div>
                    <span className='text-center'>(분)</span>
                  </div>
                </div>
                <div className='flex flex-col w-[60%]'>
                  {categories.map((category, index) => (
                    <div
                      key={index}
                      className={`w-[100%] change_2h overflow-hidden text-ellipsis whitespace-nowrap ${
                        category === '달성율(%)' ? 'border-black border-b-2' : 'b-g'
                      } page_center`}
                    >
                      {category === '목표' ? (
                        <>
                          <div className='mx-2'>목</div>
                          <div className='mx-2'>표</div>
                        </>
                      ) : category === '실적' ? (
                        <>
                          <div className='mx-2'>실</div>
                          <div className='mx-2'>적</div>
                        </>
                      ) : (
                        category
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-[40%] change_2h3 b2-r page_center'>
                  <div className=' w-[100%] flex flex-col items-center justify-center'>
                    <div className='flex flex-row items-center'>
                      <span className='font-bold text-center'>실</span>
                    <span className='text-center'>가</span>
                    <span className='text-center'>동</span>
                    </div>
                    <span className='text-center'>(분)</span>
                  </div>
                </div>
                <div className='flex flex-col w-[60%]'>
                  {categories.map((category, index) => (
                    <div
                      key={index}
                      className={`w-[100%] change_2h overflow-hidden text-ellipsis whitespace-nowrap ${
                        category === '달성율(%)' ? '' : 'b-g'
                      } page_center`}
                    >
                      {category === '목표' ? (
                        <>
                          <div className='mx-2'>목</div>
                          <div className='mx-2'>표</div>
                        </>
                      ) : category === '실적' ? (
                        <>
                          <div className='mx-2'>실</div>
                          <div className='mx-2'>적</div>
                        </>
                      ) : (
                        category
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* PM2 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>PM2</div>
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? 'border-black border-b-2' : 'b-g'
                }`}
              >
                {data.PM2.총[category] || ''} {/* 총가동 데이터 */}
              </div>
            ))}
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? '' : 'b-g'
                } `}
              >
                {data.PM2.실[category] || ''} {/* 실가동 데이터 */}
              </div>
            ))}
          </div>

          {/* PM3 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>PM3</div>
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? 'border-black border-b-2' : 'b-g'
                } `}
              >
                {data.PM3.총[category] || ''} {/* 총가동 데이터 */}
              </div>
            ))}
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? '' : 'b-g'
                }`}
              >
                {data.PM3.실[category] || ''} {/* 실가동 데이터 */}
              </div>
            ))}
          </div>

          {/* 합계 */}
          <div className='flex flex-col w-[25%] h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>합계</div>
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? 'border-black border-b-2' : 'b-g'
                }  `}
              >
                {data.합계.총[category] || ''} {/* 총가동 데이터 */}
              </div>
            ))}
            {categories.map((category, index) => (
              <div
                key={index}
                className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                  category === '달성율(%)' ? '' : 'b-g'
                } `}
              >
                {data.합계.실[category] || ''} {/* 실가동 데이터 */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CycleTimeNew;
